export default __webpack_public_path__ + "static/media/evening.6204e440.svg";